const headers = document.querySelectorAll('[data-alfresco-nook-header]');

headers.forEach((header) => {
  const navItems = header.querySelectorAll('[data-alfresco-nav-item]');
  const nav = header.querySelector('.alfresco-nook-header__nav');
  const announcement = header.querySelector('.alfresco-nook-header__announce');
  const mainHeader = header.querySelector('.alfresco-nook-header__main');
  let closeTimer;
  let scrollFrame;
  let stickyStart = 0;
  let lastScrollY = Math.max(0, window.scrollY);

  const setOverlayTop = () => {
    const anchor = header.classList.contains('is-nav-sticky') ? nav : header;
    const anchorBottom = Math.max(0, anchor?.getBoundingClientRect().bottom || 0);
    document.documentElement.style.setProperty('--alfresco-nook-overlay-top', `${anchorBottom}px`);
  };

  const syncOpenState = () => {
    const isOpen = [...navItems].some((navItem) => navItem.classList.contains('is-open'));
    header.classList.toggle('has-open-mega', isOpen);
    document.body.classList.toggle('alfresco-nook-mega-open', isOpen);

    if (isOpen) {
      if (header.classList.contains('is-nav-sticky')) header.classList.add('is-nav-visible');
      setOverlayTop();
    } else {
      document.documentElement.style.removeProperty('--alfresco-nook-overlay-top');
    }
  };

  const setMegaState = (item, isOpen) => {
    const link = item.querySelector('.alfresco-nook-header__nav-link');
    if (link) link.setAttribute('aria-expanded', String(isOpen));
    item.classList.toggle('is-open', isOpen);
    syncOpenState();
  };

  const closeAll = () => {
    navItems.forEach((item) => setMegaState(item, false));
  };

  const setStickyStart = () => {
    stickyStart =
      header.offsetTop +
      (announcement?.getBoundingClientRect().height || 0) +
      (mainHeader?.getBoundingClientRect().height || 0) +
      (nav?.getBoundingClientRect().height || 0);
  };

  const updateStickyNav = () => {
    const currentScrollY = Math.max(0, window.scrollY);
    const scrollDelta = currentScrollY - lastScrollY;
    const isPastHeader = currentScrollY > stickyStart + 8;

    header.classList.toggle('is-nav-sticky', isPastHeader);

    if (!isPastHeader) {
      header.classList.remove('is-nav-visible');
    } else if (scrollDelta < -4 || header.matches(':focus-within') || header.classList.contains('has-open-mega')) {
      header.classList.add('is-nav-visible');
    } else if (scrollDelta > 4) {
      header.classList.remove('is-nav-visible');
    }

    lastScrollY = currentScrollY;
    scrollFrame = undefined;
  };

  const requestStickyUpdate = () => {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(updateStickyNav);
  };

  navItems.forEach((item) => {
    const mega = item.querySelector('[data-alfresco-mega]');
    if (!mega) return;

    item.addEventListener('pointerenter', () => {
      window.clearTimeout(closeTimer);
      navItems.forEach((navItem) => {
        if (navItem !== item) setMegaState(navItem, false);
      });
      setMegaState(item, true);
    });

    item.addEventListener('pointerleave', () => {
      closeTimer = window.setTimeout(() => setMegaState(item, false), 90);
    });

    item.addEventListener('focusin', () => {
      navItems.forEach((navItem) => {
        if (navItem !== item) setMegaState(navItem, false);
      });
      setMegaState(item, true);
    });
  });

  header.addEventListener('focusout', () => {
    window.setTimeout(() => {
      if (!header.contains(document.activeElement)) closeAll();
    }, 0);
  });

  nav?.addEventListener('focusin', () => {
    if (header.classList.contains('is-nav-sticky')) header.classList.add('is-nav-visible');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  window.addEventListener('resize', () => {
    setStickyStart();
    requestStickyUpdate();
    if (header.classList.contains('has-open-mega')) setOverlayTop();
  });

  window.addEventListener('scroll', () => {
    requestStickyUpdate();
    if (header.classList.contains('has-open-mega')) setOverlayTop();
  }, { passive: true });

  setStickyStart();
  requestStickyUpdate();
});
